import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './app/App';
import './core/i18n/index.ts';
import './index.scss';
import * as Sentry from '@sentry/react';
import { initCacheBuster } from './core/cacheBuster';

if (window.location.hash.startsWith('#/')) {
  window.history.replaceState(null, '', window.location.hash.slice(1));
}

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Don't initialise (and don't spam errors) when no DSN is configured, e.g. local dev.
  enabled: Boolean(process.env.REACT_APP_SENTRY_DSN),
  environment: process.env.NODE_ENV,
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  // Capture 20% of transactions for performance monitoring.
  tracesSampleRate: 0.2,
});

initCacheBuster();

const router = createBrowserRouter([{ path: '*', element: <App /> }]);

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
